import Smallscore from "../../assets/images/score-small.png"
import Bigscore from "../../assets/images/score-big.png"
import "./style.scss"
export default function Score({size, score,title}){
   let count=0;
    const finalScore=[];
    if(score === 0){
      finalScore.push(<img style={{filter: 'grayscale(100%)'}} src={size==="small"? Smallscore : Bigscore} alt="score"/>)
    }else{
      for (count; count<score; count++){
        finalScore.push(<img src={size==="small"? Smallscore : Bigscore} alt="score"/>)
      }
    }
      
    return (
        <div className='score'>
             <div style={{display: title === true ? "block":"none"}}>امتیاز شما تا به این لحظه</div>
             <div className="score-coins">{finalScore}</div>
         </div>
   
    
    )}
